var map = {
	"./HTML5": [
		"./src/js/main/video/types/HTML5.ts",
		"HTML5"
	],
	"./HTML5.ts": [
		"./src/js/main/video/types/HTML5.ts",
		"HTML5"
	],
	"./Vimeo": [
		"./src/js/main/video/types/Vimeo.ts",
		"Vimeo"
	],
	"./Vimeo.ts": [
		"./src/js/main/video/types/Vimeo.ts",
		"Vimeo"
	],
	"./YouTube": [
		"./src/js/main/video/types/YouTube.ts",
		"YouTube"
	],
	"./YouTube.ts": [
		"./src/js/main/video/types/YouTube.ts",
		"YouTube"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/js/main/video/types lazy recursive ^\\.\\/.*$ referencedExports: default";
module.exports = webpackAsyncContext;